import { tv } from '@change/ds-utils';

export const ModuleSeparatorStyles = tv({
	base: 'm-0',
	variants: {
		orientation: {
			vertical: '', // keep as-is for vertical
			/*
				Not using a DS token for mobile border. That hex matches the background-overlay token but since we are
				applying it to a border, we need to use the hex directly.
			 */
			horizontal: 'border-t-[8px] !border-[#F2F1F8] md:border-t-[1px] md:!border-stroke-weaker',
		},
	},
});
